// src/components/Header.js
import React from 'react';

function Header() {
  return (
    <header>
      <h1>WeatherLeaf</h1>
    </header>
  );
}

export default Header;
